export const DOCUMENT_CATEGORY_KEY = "mnlPolicyCORRO"
